var React = require('react');

function HolyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M17.47 19.23v9.69h-3.4v-9.69a5.37 5.37 0 00-5.33-5.4 5.4 5.4 0 00-5.34 5.4v9.69H0V0h3.4v12.61a9 9 0 015.34-2.09 8.62 8.62 0 018.73 8.71M36.72 14A9.46 9.46 0 0123.4 27.26l-1.62 1.62-1.9-1.88 1.66-1.66a9.38 9.38 0 01-1.7-5.43 9.44 9.44 0 019.49-9.46 9.19 9.19 0 015.45 1.74l1.35-1.38L38 12.69zM24 22.85l8.26-8.23a5.85 5.85 0 00-3-.79 6.08 6.08 0 00-6.09 6.07 5.84 5.84 0 00.79 3zm11.39-3a6.15 6.15 0 00-1.11-3.47l-8.5 8.43A6 6 0 0029.33 26a6.08 6.08 0 006.09-6.06zM41.54 0h3.4v28.92h-3.4V0zM53.53 39.24h-3.67l4.23-10.32-7.36-18.04h3.68l5.5 13.55 5.49-13.55h3.68L53.53 39.24zM61.36 26.83h-.63v-.29h1.56v.29h-.63v2.09h-.3v-2.09zM64.51 28.92v-1.9l-.76 1.04-.76-1.04v1.9h-.3v-2.38h.32l.74 1.01.74-1.01h.32v2.38h-.3z"}));
}

HolyInline.defaultProps = {"width":"65.08","height":"39.24","viewBox":"0 0 65.08 39.24"};

module.exports = HolyInline;

HolyInline.default = HolyInline;
